import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { schoolService } from '@/api/services/schoolService'

type SLP = Parameters<typeof schoolService.list>[0]

export function useSchools(p: SLP) {
  return useQuery({ queryKey: ['schools', 'list', p], queryFn: () => schoolService.list(p), staleTime: 30_000 })
}

export function useSchool(id: number) {
  return useQuery({ queryKey: ['schools', id], queryFn: () => schoolService.getById(id), enabled: !!id })
}

export function useDeleteSchool() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => schoolService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schools'] }),
  })
}

export function useToggleSchoolStatus() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => schoolService.delete(id), // update endpoint when available
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schools'] }),
  })
}

